'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Export as Tailwind Preset.
 */ const preset = {
    content: [],
    theme: {
        extend: {
            gridTemplateRows: {
                'auto-1': 'auto minmax(0, 1fr)'
            },
            width: {
                4.5: '1.125rem'
            },
            height: {
                4.5: '1.125rem'
            },
            spacing: {
                1.25: '0.3125rem',
                1.75: '0.4375rem',
                7.5: '1.875rem',
                8.75: '2.1875rem',
                13: '3.25rem',
                15: '3.75rem',
                18: '4.5rem',
                18.5: '4.625rem',
                19: '4.75rem',
                22: '5.5rem',
                25: '6.25rem',
                26: '6.5rem',
                57.5: '14.375rem',
                58: '14.5rem',
                75: '18.75rem',
                76: '19rem',
                87: '21.75rem',
                88: '22rem',
                100: '25rem',
                104: '26rem',
                112: '28rem',
                116: '29rem',
                120: '30rem',
                128: '32rem',
                136: '34rem',
                144: '36rem',
                152: '38rem',
                160: '40rem',
                168: '42rem',
                176: '44rem',
                184: '46rem',
                192: '48rem',
                200: '50rem',
                216: '54rem',
                232: '58rem',
                248: '62rem',
                264: '66rem',
                280: '70rem',
                296: '74rem',
                312: '78rem',
                328: '82rem'
            },
            // TODO: fix lint error
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            minWidth: ({ theme })=>({
                    ...theme('width'),
                    ...theme('spacing'),
                    '4xl': '56rem',
                    '5xl': '64rem',
                    '6xl': '72rem'
                }),
            // TODO: fix lint error
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            maxWidth: ({ theme })=>({
                    ...theme('width'),
                    ...theme('spacing')
                }),
            transitionProperty: {
                width: 'width',
                background: 'background',
                gradient: '--tw-gradient-to, --tw-gradient-from'
            },
            animation: {
                shimmer: 'shimmer 2s infinite',
                'slide-right-in': 'slide-right-in 300ms ease-in-out forwards',
                'slide-right-out': 'slide-right-out 100ms ease-in-out',
                'slide-left-in': 'slide-left-in 300ms ease-in-out forwards',
                'slide-left-out': 'slide-left-out 100ms ease-in-out'
            },
            keyframes: {
                shimmer: {
                    '100%': {
                        transform: 'translateX(100%)'
                    }
                },
                'slide-right-in': {
                    '100%': {
                        transform: 'translateX(5px)'
                    }
                },
                'slide-right-out': {
                    '0%': {
                        transform: 'translateX(5px)'
                    },
                    '100%': {
                        transform: 'translateX(0%)'
                    }
                },
                'slide-left-in': {
                    '100%': {
                        transform: 'translateX(-5px)'
                    }
                },
                'slide-left-out': {
                    '0%': {
                        transform: 'translateX(-5px)'
                    },
                    '100%': {
                        transform: 'translateX(0%)'
                    }
                }
            },
            minHeight: {
                px: '1px',
                0.5: '0.125rem',
                1: '0.25rem',
                1.5: '0.375rem',
                2: '0.5rem',
                2.5: '0.625rem',
                3: '0.75rem',
                3.5: '0.875rem',
                4: '1rem',
                5: '1.25rem',
                6: '1.5rem',
                7: '1.75rem',
                7.5: '1.875rem',
                8: '2rem',
                9: '2.25rem',
                10: '2.5rem',
                11: '2.75rem',
                12: '3rem',
                14: '3.5rem',
                16: '4rem',
                20: '5rem',
                24: '6rem',
                28: '7rem',
                32: '8rem',
                36: '9rem',
                40: '10rem',
                44: '11rem',
                48: '12rem',
                52: '13rem',
                56: '14rem',
                60: '15rem',
                64: '16rem',
                72: '18rem',
                80: '20rem',
                96: '24rem',
                112: '28rem',
                116: '29rem',
                119: '29.625rem',
                152: '38rem',
                auto: 'auto',
                '1/2': '50%',
                '1/3': '33.333333%',
                '2/3': '66.666667%',
                '1/4': '25%',
                '2/4': '50%',
                '3/4': '75%',
                '1/5': '20%',
                '2/5': '40%',
                '3/5': '60%',
                '4/5': '80%',
                '1/6': '16.666667%',
                '2/6': '33.333333%',
                '3/6': '50%',
                '4/6': '66.666667%',
                '5/6': '83.333333%'
            },
            zIndex: {
                '60': '60'
            },
            borderWidth: {
                3: '3px'
            },
            fontSize: {
                tiny: [
                    '0.625rem',
                    '0.875rem'
                ],
                inherit: 'inherit'
            },
            lineHeight: {
                7.5: '1.875rem',
                12: '3rem',
                15: '3.75rem'
            }
        }
    }
};

exports.default = preset;
//# sourceMappingURL=layout.js.map
